module.exports = __webpack_public_path__ + "static/media/iPad.1c8d2bf4.jpg";